import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const getCoinBalance = async (userId) => {
    try {
        const response = await axios.get(`${API_URL}/coin-transactions/balance/${userId}`);
        return response.data.balance || 0;
    } catch (error) {
        console.error('Error fetching coin balance:', error);
        return 0;
    }
};

export const getCoinTransactions = async (userId) => {
    try {
        const response = await axios.get(`${API_URL}/coin-transactions/user/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching coin transactions:', error);
        return [];
    }
};
